import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MasterService } from '../../services/master.service';
import { SharedService } from 'src/app/shared.service';
import { GlobalService } from '../../services/global.service';
import { takeUntil } from 'rxjs/operators';
import { ResturantResponseArrayModel } from '../../models/response/resturant-response';
import { PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { I } from '@angular/cdk/keycodes';
import { ConfirmationPopupComponent } from '../../modals/confirmation-popup/confirmation-popup.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { JwtService } from '../../services/jwt.service';
import { RestaurantOrderService } from '../../services/restaurant-order.service';
@Component({
  selector: 'app-hotel-restaurants',
  templateUrl: './hotel-restaurants.component.html',
  styleUrls: ['./hotel-restaurants.component.scss'],
})
export class HotelRestaurantsComponent implements OnInit {
  @ViewChild('restaurantOrderRoomDialog') restaurantOrderRoomDialog: TemplateRef<any>;
  @Input() resturantLocationStatus: string;
  @Input() selectedCategory: string | null = null;
  headerLangHotelChangeEvent$;

  public resturantResponseArrayModel: ResturantResponseArrayModel =
    new ResturantResponseArrayModel();

  @Output() detailResturantViewEmit = new EventEmitter();
  @Output() editResturantViewEmit = new EventEmitter();

  @Output() checkResturantCount = new EventEmitter();

  innerBannerShow: boolean = false;
  viewAllShow: boolean = true;
  headdingTitle = this.translate.instant('Restaurants');
  public categories: any[] = [];
  public totalRestaurantCount: number = 0;
  /** After the guest changes the category chip (including "All"), do not auto-apply hotel default again. */
  private guestCategoryFilterTouched = false;

  length = 0;
  pageSize = 10;
  pageIndex = 0;
  restaurantWithThreshold;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  isCheckedInUser;
  // MatPaginator Output
  pageEvent: PageEvent;
  restaurantLists;
  //Loader
  title = 'materialApp';
  color = 'primary';
  mode = 'indeterminate';
  showLoader: boolean = true;
  roomOrderContextError = '';
  restaurantOrderContextLookupInProgress = false;
  restaurantLookupInProgress = false;
  pendingRestaurantInclusiveMode = false;
  pendingRestaurantName = '';
  pendingRoomNumber = '';
  pendingRoomTouched = false;
  private pendingRestaurantId = '';
  private pendingRestaurantRequestId = 0;
  private restaurantOrderRoomDialogRef: any;
  constructor(
    private router: Router,
    private masterService: MasterService,
    private sharedService: SharedService,
    public globalService: GlobalService,
    public translate: TranslateService,
    private dialog: MatDialog,
    private jwtService: JwtService,
    private restaurantOrderService: RestaurantOrderService
  ) {}

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput
      .split(',')
      .map((str) => +str);
  }

  ngOnInit() {
    // API Requests For Different Locations
    if (this.globalService.hasCheckInAuthToken()) {
      this.isCheckedInUser = true;
    }
    this.globalService.showLoader = true;
    this.checkLocation();
    // if (
    //   this.resturantLocationStatus == "home" ||
    //   this.resturantLocationStatus == "homePageMenu"
    // ) {
    //   this.showResturantLists({
    //     Data: "home",
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize
    //   });
    // }

    // if (this.resturantLocationStatus == "resturantFrontView") {
    //   this.showResturantLists({
    //     Data: "resturantFrontView",
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize
    //   });
    // }

    // if (this.resturantLocationStatus == "resturantManagePage") {
    //   this.showResturantLists({
    //     Data: null,
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize
    //   });
    // }

    this.headerLangHotelChangeEvent$ =
      this.sharedService.headerLangChangeEvent.subscribe((data: string) => {
        this.checkLocation();
      });
  }

  ngOnDestroy() {
    if (this.headerLangHotelChangeEvent$) {
      this.headerLangHotelChangeEvent$.unsubscribe();
    }
  }

  checkLocation() {
    // API Requests For Different Locations
    if (
      this.resturantLocationStatus == 'home' ||
      this.resturantLocationStatus == 'homePageMenu'
    ) {
      this.globalService.showLoader = false;
      this.showResturantLists({
        Data: 'home',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
    }

    if (this.resturantLocationStatus === 'resturantFrontView') {
      this.loadCategories(() => {
        this.showResturantLists({
          Data: 'resturantFrontView',
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          isCheckedInUser: this.isCheckedInUser ? true : false,
          categoryId: this.selectedCategory,
        });
      });
    }

    if (this.resturantLocationStatus == 'resturantManagePage') {
      this.showResturantLists({
        Data: null,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        categoryId: this.selectedCategory,
      });
    }
  }

  showResturantLists(data) {
    this.globalService.showLoader = true;
    if (this.resturantLocationStatus === 'resturantManagePage') {
      data.categoryId = this.selectedCategory;
    } else if (this.selectedCategory) {
      data.categoryId = this.selectedCategory;
    }
    if (
      this.resturantLocationStatus == 'resturantFrontView' ||
      this.resturantLocationStatus == 'home' ||
      this.resturantLocationStatus == 'homePageMenu'
    ) {
      this.globalService.showLoader = true;
      this.masterService
        .showResturantLists(data)
        .pipe(takeUntil(this.globalService.componentDestroyed(this)))
        .subscribe(
          (response) => {
            if (response.Status) {
              this.resturantResponseArrayModel =
                this.globalService.jsonConvert.deserializeObject(
                  response.Data,
                  ResturantResponseArrayModel
                );
              this.globalService.showLoader = false;
              let resturantResponseArray = this.resturantResponseArrayModel;

              if (this.resturantResponseArrayModel.CountLists) {
                this.length = this.resturantResponseArrayModel.CountLists;
              }

              if (
                this.resturantResponseArrayModel.ResturantLists &&
                this.resturantResponseArrayModel.ResturantLists.length
              ) {
                this.checkResturantCount.emit(
                  this.resturantResponseArrayModel.ResturantLists.length
                );
              } else {
                this.checkResturantCount.emit(0);
              }
            } else {
              this.globalService.showLoader = false;
              // this.globalService.handleApiError(response);
            }
          },
          (error) => {
            this.globalService.showLoader = false;
            // this.globalService.handleApiError(error);
          }
        );
    } else {
      const restaurantListRequest = this.globalService.isPortalStaffRoute()
        ? this.restaurantOrderService.getRestaurants(data)
        : this.masterService.showResturantListsAdmin(data);
      restaurantListRequest
        .pipe(takeUntil(this.globalService.componentDestroyed(this)))
        .subscribe(
          (response) => {
            if (response.Status) {
              this.globalService.showLoader = false;
              this.restaurantWithThreshold =
                response.Data.restaurantWithThreshold;
              this.resturantResponseArrayModel =
                this.globalService.jsonConvert.deserializeObject(
                  response.Data,
                  ResturantResponseArrayModel
                );

              let resturantResponseArray = this.resturantResponseArrayModel;

              if (this.resturantResponseArrayModel.CountLists) {
                this.length = this.resturantResponseArrayModel.CountLists;
              }

              if (
                this.resturantResponseArrayModel.ResturantLists &&
                this.resturantResponseArrayModel.ResturantLists.length
              ) {
                this.restaurantLists =
                  this.resturantResponseArrayModel.ResturantLists;
                this.checkResturantCount.emit(
                  this.resturantResponseArrayModel.ResturantLists.length
                );
              } else {
                this.checkResturantCount.emit(0);
              }
            } else {
              this.globalService.showLoader = false;
              // this.globalService.handleApiError(response);
            }
          },
          (error) => {
            this.globalService.showLoader = false;
            // this.globalService.handleApiError(error);
          }
        );
    }
  }

  loadCategories(onLoaded?: () => void) {
    this.masterService
      .fetchModuleCategoriesPublic({
        ModuleType: 'restaurant',
        LangKey: this.globalService.getLangAccToUser(),
        Subdomain: window.localStorage.getItem('Subdomain'),
        isCheckedInUser: !!this.isCheckedInUser,
      })
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          if (response.Status) {
            this.categories = response.Data.categories || [];
            this.totalRestaurantCount = response.Data.TotalCount || 0;
            if (
              this.resturantLocationStatus === 'resturantFrontView' &&
              !this.guestCategoryFilterTouched &&
              response.Data.DefaultCategoryId
            ) {
              const defaultId = String(response.Data.DefaultCategoryId);
              const inList = (this.categories || []).some(
                (c: any) => String(c._id) === defaultId
              );
              if (inList) {
                this.selectedCategory = defaultId;
              }
            }
          } else {
            this.categories = [];
            this.totalRestaurantCount = 0;
          }
          if (onLoaded) {
            onLoaded();
          }
        },
        () => {
          this.categories = [];
          this.totalRestaurantCount = 0;
          if (onLoaded) {
            onLoaded();
          }
        }
      );
  }

  scrollCategoryStrip(direction: number, el: HTMLElement | null | undefined): void {
    if (!el) {
      return;
    }
    const step = Math.min(200, Math.floor(el.clientWidth * 0.75));
    el.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  filterByCategory(categoryId: string | null) {
    this.guestCategoryFilterTouched = true;
    this.selectedCategory = categoryId;
    this.pageIndex = 0;
    this.showResturantLists({
      Data: this.resturantLocationStatus === 'resturantFrontView' ? 'resturantFrontView' : null,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      isCheckedInUser: this.isCheckedInUser ? true : false,
      categoryId: categoryId,
    });
  }

  getCategoryName(category: any): string {
    if (!category || !category.CategoryNames || category.CategoryNames.length === 0) {
      return '';
    }

    const currentLang = this.globalService.getLangAccToUser();
    const resolved = this.globalService.localizedArrayValue(
      category.CategoryNames,
      currentLang
    );
    if (resolved) {
      return resolved;
    }

    return category.CategoryNames[0].Value || '';
  }

  detailResturantView(data) {
    this.detailResturantViewEmit.emit(data);
  }
  editResturantView(data) {
    this.editResturantViewEmit.emit(data);
  }

  openRestaurantOrders(restaurant: any): void {
    const restaurantId = restaurant?._id || restaurant;
    const requestId = ++this.pendingRestaurantRequestId;
    this.pendingRestaurantId = restaurantId;
    this.roomOrderContextError = '';
    this.restaurantOrderContextLookupInProgress = false;
    this.pendingRoomTouched = false;
    this.pendingRoomNumber = '';
    this.restaurantLookupInProgress = true;
    this.globalService.showLoader = true;
    this.restaurantOrderService
      .getRestaurant({ ResturantId: restaurantId })
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          if (
            requestId !== this.pendingRestaurantRequestId ||
            restaurantId !== this.pendingRestaurantId
          ) {
            return;
          }

          this.restaurantLookupInProgress = false;
          this.globalService.showLoader = false;
          if (!response?.Status || !response?.Data) {
            this.globalService.handleApiError(response);
            return;
          }

          const inclusiveMode = response.Data.InclusiveMode;
          this.pendingRestaurantInclusiveMode =
            inclusiveMode === true || inclusiveMode === 1 || inclusiveMode === 'true';
          this.pendingRestaurantName =
            response.Data.ResturantNameLangs?.[0]?.Value || 'Restaurant';

          if (!this.pendingRestaurantInclusiveMode) {
            this.router.navigate(
              this.globalService.getPortalManageRestaurantsRoute(restaurantId, 'tables'),
              { state: { restaurantName: this.pendingRestaurantName } }
            );
            return;
          }

          this.restaurantOrderRoomDialogRef = this.dialog.open(this.restaurantOrderRoomDialog, {
            width: '360px',
            height: 'auto',
            panelClass: 'cm-md-modal',
            disableClose: true,
          });
        },
        (error) => {
          if (requestId !== this.pendingRestaurantRequestId) {
            return;
          }

          this.restaurantLookupInProgress = false;
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }

  get pendingRestaurantOrderInvalid(): boolean {
    return !this.pendingRoomNumber.trim();
  }

  get pendingRoomError(): string {
    return this.pendingRoomTouched && this.pendingRestaurantOrderInvalid
      ? 'Room number is required'
      : '';
  }

  onPendingRoomNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.slice(0, 30);
    input.value = value;
    this.pendingRoomNumber = value;
    this.pendingRoomTouched = true;
    this.roomOrderContextError = '';
  }

  continueRestaurantOrder(): void {
    if (this.restaurantOrderContextLookupInProgress) {
      return;
    }

    if (this.pendingRestaurantOrderInvalid) {
      this.pendingRoomTouched = true;
      return;
    }

    const roomNumber = this.pendingRoomNumber.trim();
    this.restaurantOrderContextLookupInProgress = true;
    this.roomOrderContextError = '';
    this.restaurantOrderService
      .createRoomOrderContext({
        ResturantId: this.pendingRestaurantId,
        roomNo: roomNumber,
        LangKey: this.globalService.gethotelLangTranslate(),
      })
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          const roomOrderToken = response?.Data?.RoomOrderToken;
          if (!response?.Status || !roomOrderToken) {
            this.restaurantOrderContextLookupInProgress = false;
            this.roomOrderContextError =
              response?.Message ||
              'Unable to verify the permanent resident for this room';
            return;
          }

          this.restaurantOrderContextLookupInProgress = false;
          this.restaurantOrderRoomDialogRef?.close();
          this.restaurantOrderService.start({
            restaurantId: this.pendingRestaurantId,
            inclusiveMode: true,
            roomNumber: response.Data.roomNo || roomNumber,
            roomOrderToken,
          });
        },
        (error) => {
          this.restaurantOrderContextLookupInProgress = false;
          this.roomOrderContextError =
            error?.error?.Message ||
            error?.Message ||
            'Unable to verify the permanent resident for this room';
        }
      );
  }

  deactivateFromHome(id) {
    let lists = this.resturantResponseArrayModel.ResturantLists;

    let findIndex = lists.findIndex((list) => list._id === id);

    this.globalService.showLoader = true;
    this.masterService
      .updateResturantHomeStatus({
        Lang: this.masterService.getLangSaveProperty(),
        Id: id,
      })
      .subscribe(
        (response) => {
          if (response.Status) {
            this.globalService.showLoader = false;
            this.resturantResponseArrayModel.ResturantLists.splice(
              findIndex,
              1
            );
          } else {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(response);
          }
        },
        (error) => {
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }

  thresholdCheck(id) {
    if (this.restaurantWithThreshold.length > 0) {
      for (let i = 0; this.restaurantWithThreshold.length > i; i++) {
        if (this.restaurantWithThreshold[i].restaurantId == id) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  getPaginatorData(event) {
    // API Requests For Different Locations
    if (this.resturantLocationStatus == 'resturantFrontView') {
      this.showResturantLists({
        Data: 'resturantFrontView',
        pageIndex: event.pageSize * event.pageIndex,
        pageSize: event.pageSize,
        isCheckedInUser: this.isCheckedInUser ? true : false,
        categoryId: this.selectedCategory,
      });
    } else {
      this.showResturantLists({
        Data: null,
        pageIndex: event.pageSize * event.pageIndex,
        pageSize: event.pageSize,
        categoryId: this.selectedCategory,
      });
    }
  }

  onToggleChange(event: MatSlideToggleChange, id: number, serviceName: string) {
    if (!this.canWriteRestaurants()) {
      event.source.checked = !event.checked;
      return;
    }
    // Immediately revert the toggle until confirmation
    event.source.checked = !event.checked;
    this.openDialog(id, serviceName, event.checked);
  }

  openDialog(id: number, serviceName: string, willBeEnabled: boolean) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '446px',
      panelClass: 'confirmation-modal-popup',
      data: {
        serviceId: id,
        serviceName: serviceName,
        willBeEnabled: willBeEnabled,
        location: 'resturant',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // User confirmed the action
        this.updateRestaurantStatus(result);
      } else {
        // User canceled, reset the toggle
        // this.isToggleChecked = !this.isToggleChecked;
      }
    });
  }

  // Add this method to handle the service status update
  updateRestaurantStatus(data: any) {
    const payload = {
      ResturantId: data.serviceId,
      ServiceId:null,
      Data: {
        IsActive: data.willBeEnabled,
        CommentStatus: !data.willBeEnabled
          ? data.reason === 'Other'
            ? data.otherReason
            : data.reason
          : null,
      },
    };

    this.globalService.showLoader = true;
    this.masterService
      .updateServiceRestaurantStatus(payload)
      .pipe(takeUntil(this.globalService.componentDestroyed(this)))
      .subscribe(
        (response) => {
          this.globalService.showLoader = false;
          if (response.Status) {
            // Update the service status in your local data
            this.showResturantLists({
              Data: null,
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
            });
            this.updateLocalServiceStatus(data.serviceId, data.willBeEnabled);
            this.globalService.handleSuccessMessage(
              `Service successfully ${
                data.willBeEnabled ? 'enabled' : 'disabled'
              }`
            );
          } else {
            this.globalService.handleApiError(response);
          }
        },
        (error) => {
          this.globalService.showLoader = false;
          this.globalService.handleApiError(error);
        }
      );
  }
  updateLocalServiceStatus(serviceId: number, isActive: boolean) {
    // Find and update the service in your restaurantLists or wherever you store it
    const service = this.restaurantLists.find(s => s.id === serviceId);
    if (service) {
      service.IsActive = isActive;
    }
  }

  private canWriteRestaurants(): boolean {
    if (this.jwtService.getUserRole && this.jwtService.getUserRole() === 'admin') {
      return true;
    }
    try {
      const bulk = JSON.parse(window.localStorage['bulkPermissions'] || 'null');
      const row = Array.isArray(bulk)
        ? bulk.find((item: any) => item?.nameKey === 'restaurants' || item?.NameKey === 'restaurants')
        : null;
      const raw = row?.permissions?.[0] || row?.Permissions?.[0];
      if (!raw) {
        return false;
      }
      return !!(raw.full ?? raw.Full) || !!(raw.manage ?? raw.Manage);
    } catch {
      return false;
    }
  }
}
